import { Accordion, classNames } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { AiSubtitlesEditorInfo } from '../../../../components/ai-subtitles-editor-info';
import { useGetWebcastSetupSummaryQuery } from '../../../../generated/graphql-manager';

import styles from './setup-summary.module.css';

export function AiSubtitlesInfo() {
  const { webcastId = '' } = useParams();
  const { t } = useTranslation();

  const { data, loading } = useGetWebcastSetupSummaryQuery({ variables: { webcastId } });

  const streams = data?.webcast?.streaming?.live?.streams.map((stream) => ({
    language: stream?.metadata?.language || null,
    aiLiveTranscriptEditorSettings: stream?.aiLiveTranscriptEditorSettings || null,
  }));

  if (loading || !streams) return null;

  const enabled = streams.some((stream) => stream?.aiLiveTranscriptEditorSettings !== null);

  return (
    <Accordion
      data-testid="ai-subtitles-info-accordion"
      disabled={!enabled}
      buttonContent={
        <div className={classNames(styles.accordionLabel, !enabled && styles.disabled)}>
          <span>{t('manager.webcastSetup.summary.aiSubtitles.title')}</span>
          <span data-testid="ai-subtitles-info-label">{enabled ? t('common.enabled') : t('common.disabled')}</span>
        </div>
      }
    >
      <AiSubtitlesEditorInfo streams={streams} />
    </Accordion>
  );
}
